'use strict';exports.__esModule = true;exports.contactAgencyOnPropertyCreation = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var contactAgencyOnPropertyCreation = (0, _reduxAct.createAction)('CONTACT_AGENCY_ON_PROPERTY_CREATION');
var contactAgencyOnPropertyCreationSuccess = (0, _reduxAct.createAction)('/CONTACT_AGENCY_ON_PROPERTY_CREATION_SUCCESS');
var contactAgencyOnPropertyCreationFail = (0, _reduxAct.createAction)('/CONTACT_AGENCY_ON_PROPERTY_CREATION_FAIL');

var initialState = {
  formError: null,
  formSubmitting: false,
  formSubmitted: false };


var submitContactAgencyOnPropertyCreation = function submitContactAgencyOnPropertyCreation(_ref) {var access_token = _ref.access_token,data = _ref.data;return _axios2.default.
  post('messaging/contact-agency-on-property-creation', data, { headers: { access_token: access_token } }).
  then(contactAgencyOnPropertyCreationSuccess).
  catch(contactAgencyOnPropertyCreationFail);};

var handleContactAgencyOnPropertyCreation = function handleContactAgencyOnPropertyCreation(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitting: true,
    formSubmitted: false }),
  promise(submitContactAgencyOnPropertyCreation, action));};

var handlecCntactAgencyOnPropertyCreationSuccess = function handlecCntactAgencyOnPropertyCreationSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null });};


var handleContactAgencyOnPropertyCreationFail = function handleContactAgencyOnPropertyCreationFail(state, _ref2) {var response = _ref2.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};


var contactAgencyOnProperty = (0, _reduxAct.createReducer)(function (on) {
  on(contactAgencyOnPropertyCreation, handleContactAgencyOnPropertyCreation);
  on(contactAgencyOnPropertyCreationSuccess, handlecCntactAgencyOnPropertyCreationSuccess);
  on(contactAgencyOnPropertyCreationFail, handleContactAgencyOnPropertyCreationFail);
}, initialState);exports.

contactAgencyOnPropertyCreation = contactAgencyOnPropertyCreation;exports.default =

contactAgencyOnProperty;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/contactAgencyOnPropertyCreation.js
// module id = 1272
// module chunks = 0